import { render, staticRenderFns } from "./qLanguageTab.vue?vue&type=template&id=985c667a&"
import script from "./qLanguageTab.vue?vue&type=script&lang=ts&"
export * from "./qLanguageTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports